import { render, staticRenderFns } from "./customer-order.vue?vue&type=template&id=61ac533e&scoped=true&"
import script from "./customer-order.vue?vue&type=script&lang=js&"
export * from "./customer-order.vue?vue&type=script&lang=js&"
import style0 from "./customer-order.vue?vue&type=style&index=0&id=61ac533e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ac533e",
  null
  
)

export default component.exports